export default {
  setUserLocalStorage(data) {
    const id = data.args[0].id
    const name = data.args[0].first_name
    const last_name = data.args[0].last_name
    const username = data.args[0].roles['mrn:party_role:user'].username
    const photo = data.args[0].photo || ''
    const user = {
      name,
      last_name,
      username
    }

    //Usuario ya estuvo logeado
    //Verificar si es el mismo usuario, en caso contrario reemplazo los datos
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('user_id', id)
    localStorage.setItem('user_avatar', photo)
  }
}
